module.exports = __webpack_public_path__ + "img/dreams_en.725802e.jpg";